import React from 'react';

export function ClickableConditionLabel({ condition, onClickCondition }) {
  return (
    <div className='search-item' onClick={() => onClickCondition(condition)}>
      {condition.name}
    </div>
  );
}
